import React, { useEffect } from 'react';
import QuizBuilder from "./flow";
import { useQuizz } from "../../../application/quizz/hooks/useQuizz";
import NavigationService from '../../../utils/history';

const QuizViewPage = (props) => {
    const { updateQuizz, quizz, getById, goBack } = useQuizz(props);

    useEffect(() => {
        const id = props.match?.params?.id;
        if (id) {
            getById(id);
        }
    }, [props.match?.params?.id, getById]);

    const update = async (data) => {
        const id = props.match?.params?.id;
        if (id) {
            await updateQuizz(id, data);
            goBack();
        }
    };
    return (
        <QuizBuilder goBack={goBack} editMode={true} initialData={quizz} onSubmit={(data) => update(data)} />
    )
}

export default QuizViewPage;